import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { NetworkStatus } from '@cbridge-utils/network';
import { CoverageAccountAction } from './coverageAccount.action';
import { coverageAccountInitialState } from './coverageAccount.constant';
import { ICoverageAccountStore } from './coverageAccount.interface';

export const coverageAccountReducer = reducerWithInitialState(coverageAccountInitialState)
  .case(CoverageAccountAction.loadList.started, (state): ICoverageAccountStore => ({
    ...state,
    listNetworkStatus: NetworkStatus.Started,
  }))
  .case(CoverageAccountAction.loadList.done, (state, { result }): ICoverageAccountStore => ({
    ...state,
    data: Object.fromEntries(result.map((account) => [account.accountId, account])),
    listNetworkStatus: NetworkStatus.Done,
  }))
  .case(CoverageAccountAction.loadList.failed, (state): ICoverageAccountStore => ({
    ...state,
    listNetworkStatus: NetworkStatus.Failed,
  }))
  .case(CoverageAccountAction.remove.done, (state, { params }): ICoverageAccountStore => {
    const data = { ...state.data };
    delete data[params.accountId];
    return { ...state, data };
  })
  .case(CoverageAccountAction.removeByReport, (state, { reportId }): ICoverageAccountStore => ({
    ...state,
    data: Object.fromEntries(Object.entries(state.data).filter(([, account]) => account.reportId !== reportId)),
  }))
  .case(CoverageAccountAction.destroy, () => ({ ...coverageAccountInitialState }));
